// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/line_desktop.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Shop_container__Rufq5 {
  padding-top: 124px;
  transition: all 0.2s linear;
}
.Shop_container__Rufq5 .Shop_container__line__TdNwk {
  margin-top: 20px;
  border-radius: 8px;
  width: 100%;
  height: 52px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 0 10px;
}
.Shop_container__Rufq5 .Shop_container__line__TdNwk .Shop_title__iyk0e {
  font-weight: 400;
  font-size: 18px;
  line-height: 163%;
  color: #ffc785;
  padding-top: 10px;
}
.Shop_container__Rufq5 .Shop_container__line_mob__SyPyr {
  display: none;
}
.Shop_container__Rufq5 .Shop_container__title__8fnZF {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  display: flex;
  justify-content: space-between;
  align-items: end;
}
.Shop_container__Rufq5 .Shop_container__title__8fnZF .Shop_title__iyk0e {
  font-size: 48px;
  font-weight: 700;
  font-style: normal;
  align-items: center;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  font-size: 40px;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 30px;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K .Shop_reset_filter__qOm9O {
  cursor: pointer;
  font-size: 14px;
  color: #E0E0E0;
  display: flex;
  gap: 4px;
  align-items: center;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K .Shop_chips__container__Gc8va {
  display: flex;
  gap: 12px;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K .Shop_chips__container_item__dZvxn {
  background-color: rgba(220, 220, 220, 0.05);
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
  border-radius: 100px;
  padding: 10px 16px;
  color: #ffffff;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K .Shop_chips__container_item__dZvxn img {
  display: none;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K .Shop_selected_chips__container_item__tqYya {
  background: rgba(255, 255, 255, 0.3);
  color: #fff;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K .Shop_selected_chips__container_item__tqYya img {
  display: block;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K .Shop_chips__container_divider__Ud1TA {
  color: #fff;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filter__WLyHN {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  background-color: #3a2159;
  border-radius: 8px;
  color: #ae6fff;
  cursor: pointer;
  display: flex;
  gap: 8px;
  height: 46px;
  padding: 10px 22px;
  position: relative;
  transition: all 0.2s linear;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filter__WLyHN .Shop_filterWrapper__xmtgw {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  background-color: #230432;
  border-radius: 8px;
  color: #e0e0e0;
  left: 0;
  padding: 10px 0;
  position: absolute;
  top: 100%;
  max-width: 158px;
  z-index: 0;
  white-space: nowrap;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filter__WLyHN .Shop_filterWrapper__xmtgw .Shop_filterItem__nc6Uh {
  cursor: pointer;
  margin-bottom: 9px;
  padding: 6px 16px;
  transition: all 0.2s linear;
  border-radius: 4px;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filter__WLyHN .Shop_filterWrapper__xmtgw .Shop_filterItem__nc6Uh:hover {
  background-color: rgba(220, 220, 220, 0.1);
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filter__WLyHN .Shop_filterWrapper__xmtgw .Shop_selectedFilter__Xqs1D {
  background-color: rgba(220, 220, 220, 0.1);
  color: #fff;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filter__WLyHN:hover {
  background-color: #4a2c6f;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filterModal__MBXhI {
  display: none;
}
.Shop_container__Rufq5 .Shop_wrapper__0a8zU {
  align-items: start;
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-top: 50px;
}
.Shop_container__Rufq5 .Shop_wrapper__0a8zU .Shop_loaderContainer__eMAAr {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  color: #f9f9f9;
  display: flex;
  grid-column: span 4;
  justify-content: center;
  margin-top: 50px;
}
.Shop_container__Rufq5 .Shop_wrapper__0a8zU .Shop_loaderContainer__eMAAr .Shop_loaderWrapper__IRTM8 {
  background-color: #ffffff;
  border-radius: 133px;
  height: 8px;
  margin-top: 32px;
  width: 236px;
}
.Shop_container__Rufq5 .Shop_wrapper__0a8zU .Shop_loaderContainer__eMAAr .Shop_loaderWrapper__IRTM8 .Shop_loader__PVrLC {
  background-color: #4a2c6f;
  border-radius: 133px;
  height: 100%;
  animation: Shop_loader__PVrLC 0.5s ease-in-out forwards;
  width: 0;
}
.Shop_container__Rufq5 .Shop_wrapper__0a8zU .Shop_empty__GgfIa {
  font-size: 32px;
  font-weight: 700;
  font-style: normal;
  color: #ffffff;
  grid-column: span 4;
  margin-top: 50px;
  text-align: center;
}
.Shop_container__Rufq5 .Shop_wrapper__0a8zU .Shop_empty__GgfIa .Shop_emptyInfo__lQmg0 {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  margin-top: 20px;
}
.Shop_container__Rufq5 .Shop_wrapper__0a8zU .Shop_empty__GgfIa .Shop_emptyInfo__lQmg0 .Shop_link__oVSYa {
  color: #FD4C0A;
}
.Shop_container__Rufq5 .Shop_more__FgEWY {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  position: relative;
}
.Shop_container__Rufq5 .Shop_up__9HpLo {
  align-items: center;
  background-color: #3a2159;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  position: absolute;
  right: 0;
  transition: all 0.2s linear;
  width: 40px;
}
.Shop_container__Rufq5 .Shop_up__9HpLo:hover {
  background-color: #4a2c6f;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 .Shop_modalImage__-TgFp {
  width: 84px;
  height: 84px;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 .Shop_modalContent__3ZzSx {
  background: #2d083e;
  padding: 20px;
  border-radius: 8px;
  max-width: 540px;
  width: 90%;
  max-height: 80%;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 .Shop_modalContent_top_button__uSw-s {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 .Shop_modalContent_top_button__uSw-s .Shop_modalContent_top_button_name__Mz-Xw {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  color: #f9f8fa;
  margin: 0 auto;
  font-size: 24px;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 .Shop_modalContent_top_button__uSw-s .Shop_modalContent_top_button_x__4YHZ7 {
  cursor: pointer;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 .Shop_modal_inner__UlMxW {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  gap: 16px;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 .Shop_modal_inner__UlMxW .Shop_modal_inner_price__Nd91E {
  border-radius: 100px;
  width: 120px;
  height: 28px;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 .Shop_modal_inner__UlMxW .Shop_modal_inner_price__Nd91E .Shop_modal_inner_price_p__Vu0-Q {
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  background: rgba(220, 220, 220, 0.1);
  border-radius: 16px;
  padding: 6px 8px;
  width: auto;
  height: 31px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 13px;
  color: #dcdcdc;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 .Shop_modal_inner__UlMxW .Shop_modal_inner_name__TeW6E .Shop_modal_inner_name_n__tfh4z {
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  color: #ffffff;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 .Shop_modal_inner__UlMxW .Shop_modal_inner_desc__BlsOk .Shop_modal_inner_desc_d__Wi7w4 {
  font-weight: 400;
  font-size: 14px;
  color: #e0e0e0;
  line-height: 1.5em;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 .Shop_modal_inner_buttons__sbOhH {
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: end;
  align-items: center;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 .Shop_modal_inner_buttons__sbOhH .Shop_modal_inner_buttons_take__d4XVI {
  background: #fd4c0a;
  border-radius: 8px;
  width: 84px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 .Shop_modal_inner_buttons__sbOhH .Shop_modal_inner_buttons_take__d4XVI .Shop_modal_inner_buttons_take_t__kP72n {
  font-weight: 500;
  font-size: 14px;
  color: #1b1e23;
  cursor: pointer;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 .Shop_modal_inner_buttons_cancel__U44It {
  display: flex;
  justify-content: end;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 .Shop_modal_inner_buttons_cancel__U44It .Shop_modal_inner_buttons_cancel_c__evcK\\+ {
  display: flex;
  justify-content: end;
  cursor: pointer;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 .Shop_closeBtn__Bg1v3 {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

@keyframes Shop_loader__PVrLC {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
@media (max-width: 1200px) {
  .Shop_container__Rufq5 .Shop_wrapper__0a8zU {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media (max-width: 1100px) {
  .Shop_container__Rufq5 .Shop_container__filter__FspMS {
    align-items: flex-start;
    flex-direction: row;
    margin-top: 32px;
    gap: 16px;
  }
  .Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K {
    display: none;
  }
  .Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filterModal__MBXhI {
    background: #fd4c0a;
    color: #fff;
    display: flex;
  }
  .Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filterModal__MBXhI:hover {
    background-color: #fd4c0a;
  }
}
@media (max-width: 920px) {
  .Shop_container__filter__FspMS .Shop_chips__rCH6K {
    display: flex;
    flex-direction: column;
  }
  .Shop_container__filter__FspMS .Shop_chips__container_divider__Ud1TA {
    display: none;
  }
}
@media (max-width: 850px) {
  .Shop_container__Rufq5 {
    padding-top: 104px;
  }
  .Shop_container__Rufq5 .Shop_container__title__8fnZF .Shop_title__iyk0e {
    display: block;
    font-size: 36px;
  }
  .Shop_container__Rufq5 .Shop_container__filter__FspMS {
    align-items: start;
  }
  .Shop_container__Rufq5 .Shop_wrapper__0a8zU {
    grid-template-columns: 1fr;
    margin-top: 24px;
  }
  .Shop_container__Rufq5 .Shop_wrapper__0a8zU .Shop_empty__GgfIa {
    font-size: 24px;
    font-weight: 700;
    font-style: normal;
  }
  .Shop_container__Rufq5 .Shop_wrapper__0a8zU .Shop_empty__GgfIa .Shop_emptyInfo__lQmg0 {
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
    margin-top: 20px;
  }
}
@media (max-width: 500px) {
  .Shop_container__Rufq5 .Shop_container__line__TdNwk {
    display: none;
  }
  .Shop_container__Rufq5 .Shop_container__line_mob__SyPyr {
    margin-top: 20px;
    display: block;
    border-radius: 8px;
    width: 100%;
    height: 100%;
    background: rgba(255, 112, 0, 0.25);
    display: flex;
    gap: 6px;
    padding: 10px 10px;
    align-items: center;
  }
  .Shop_container__Rufq5 .Shop_container__line_mob__SyPyr .Shop_mob_line__N5FaG {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .Shop_container__Rufq5 .Shop_container__line_mob__SyPyr .Shop_mob_line__N5FaG .Shop_title__iyk0e {
    font-weight: 600;
    font-size: 18px;
    line-height: 168%;
    color: #fff;
  }
  .Shop_container__Rufq5 .Shop_container__line_mob__SyPyr .Shop_mob_line__N5FaG .Shop_desc__ReiWU {
    font-family: var(--second-family);
    font-weight: 400;
    font-size: 12px;
    line-height: 173%;
    color: #ffc785;
  }
}
@media (max-width: 330px) {
  .Shop_container__Rufq5 .Shop_container__filter__FspMS {
    align-items: flex-start;
    flex-direction: column-reverse;
    margin-top: 32px;
    gap: 16px;
  }
  .Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K {
    display: none;
  }
  .Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filterModal__MBXhI {
    background: #fd4c0a;
    color: #fff;
    display: flex;
  }
  .Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filterModal__MBXhI:hover {
    background-color: #fd4c0a;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Shop/Shop.module.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,2BAAA;AADF;AAEE;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAAJ;AACI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AACN;AAEE;EACE,aAAA;AAAJ;AAEE;ECcA,eAAA;EACA,gBAAA;EACA,kBAAA;EDdE,aAAA;EACA,8BAAA;EACA,gBAAA;AAEJ;AADI;EC3BF,eAAA;EACA,gBAAA;EACA,kBAAA;ED4BI,mBAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;AAIN;AAAE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAEJ;AADI;ECWF,eAAA;EACA,gBAAA;EACA,kBAAA;EDXI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAKN;AAHM;EACE,eAAA;EACA,eAAA;EACA,cEtDO;EFuDP,aAAA;EACA,QAAA;EACA,mBAAA;AAKR;AAFM;EACE,aAAA;EACA,SAAA;AAIR;AAFM;EACE,2CAAA;EACA,qEAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAIR;AAFQ;EACE,aAAA;AAIV;AADM;EACE,oCAAA;EACA,WAAA;EACA,qEAAA;AAGR;AADQ;EACE,cAAA;AAGV;AAAM;EACE,WAAA;AAER;AAEI;ECnDF,eAAA;EACA,gBAAA;EACA,kBAAA;EDoDI,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;AACN;AACM;ECtDJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDuDM,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;AAER;AAAQ;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;AAEV;AAAU;EACE,0CAAA;AAEZ;AAEQ;EACE,0CAAA;EACA,WAAA;AAAV;AAIM;EACE,yBAAA;AAFR;AAMI;EACE,aAAA;AAJN;AAOE;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,sCAAA;EACA,gBAAA;AALJ;AAOI;EChJF,eAAA;EACA,gBAAA;EACA,kBAAA;EDiJI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAJN;AAMM;EACE,yBE7KE;EF8KF,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AAJR;AAMQ;EACE,yBAAA;EACA,oBAAA;EACA,YAAA;EACA,uDAAA;EACA,QAAA;AAJV;AASI;EChLF,eAAA;EACA,gBAAA;EACA,kBAAA;EDiLI,cEhMI;EFiMJ,mBAAA;EACA,gBAAA;EACA,kBAAA;AANN;AAQM;EC1JJ,eAAA;EACA,gBAAA;EACA,kBAAA;ED2JM,gBAAA;AALR;AAOQ;EACE,cElMC;AF6LX;AAWE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AATJ;AAYE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AAVJ;AAYI;EACE,yBAAA;AAVN;AAaE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EAEA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAZJ;AAaI;EACE,WAAA;EACA,YAAA;AAXN;AAaI;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AAXN;AAaI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAXN;AAYM;ECxNJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDwNM,cAAA;EACA,cAAA;EACA,eAAA;AARR;AAUM;EACE,eAAA;AARR;AAWI;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;AATN;AAUM;EACE,oBAAA;EACA,YAAA;EACA,YAAA;AARR;AAUQ;EC1NN,eAAA;EACA,gBAAA;EACA,kBAAA;ED0NQ,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AANV;AAUQ;EC1ON,eAAA;EACA,gBAAA;EACA,kBAAA;ED0OQ,gBAAA;EACA,eAAA;EACA,cAAA;AANV;AAUQ;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AARV;AAYI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;AAVN;AAYM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAVR;AAWQ;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AATV;AAaI;EACE,aAAA;EACA,oBAAA;AAXN;AAYM;EACE,aAAA;EACA,oBAAA;EACA,eAAA;AAVR;AAcI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAZN;;AAiBA;EACE;IACE,QAAA;EAdF;EAiBA;IACE,WAAA;EAfF;AACF;AAkBA;EAEI;IACE,kCAAA;EAjBJ;AACF;AAqBA;EAEI;IACE,uBAAA;IACA,mBAAA;IACA,gBAAA;IACA,SAAA;EApBJ;EAsBI;IACE,aAAA;EApBN;EAuBI;IACE,mBAAA;IACA,WAAA;IACA,aAAA;EArBN;EAuBM;IACE,yBAAA;EArBR;AACF;AA2BA;EAEI;IACE,aAAA;IACA,sBAAA;EA1BJ;EA4BE;IACE,aAAA;EA1BJ;AACF;AA8BA;EACE;IACE,kBAAA;EA5BF;EA8BI;IACE,cAAA;IACA,eAAA;EA5BN;EAgCE;IACE,kBAAA;EA9BJ;EAmCE;IACE,0BAAA;IACA,gBAAA;EAjCJ;EAmCI;ICnaJ,eAAA;IACA,gBAAA;IACA,kBAAA;EDmYA;EAiCM;IC5XN,eAAA;IACA,gBAAA;IACA,kBAAA;ID6XQ,gBAAA;EA9BR;AACF;AAoCA;EAEI;IACE,aAAA;EAnCJ;EAqCE;IACE,gBAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,mCAAA;IACA,aAAA;IACA,QAAA;IACA,kBAAA;IACA,mBAAA;EAnCJ;EAoCI;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;EAlCN;EAmCM;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,WAAA;EAjCR;EAmCM;IACE,iCAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,cAAA;EAjCR;AACF;AAsCA;EAEI;IACE,uBAAA;IACA,8BAAA;IACA,gBAAA;IACA,SAAA;EArCJ;EAuCI;IACE,aAAA;EArCN;EAwCI;IACE,mBAAA;IACA,WAAA;IACA,aAAA;EAtCN;EAwCM;IACE,yBAAA;EAtCR;AACF","sourcesContent":["@import \"../../assets/styles/global.scss\";\n\n.container {\n  padding-top: 124px;\n  transition: all 0.2s linear;\n  .container__line {\n    margin-top: 20px;\n    border-radius: 8px;\n    width: 100%;\n    height: 52px;\n    background-image: url(\"../../assets/images/line_desktop.png\");\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    padding: 0 10px;\n    .title {\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 163%;\n      color: #ffc785;\n      padding-top: 10px;\n    }\n  }\n  .container__line_mob {\n    display: none;\n  }\n  .container__title {\n    @include subtitle5;\n    display: flex;\n    justify-content: space-between;\n    align-items: end;\n    .title {\n      @include h2;\n\n      align-items: center;\n      color: #ffffff;\n      display: flex;\n      justify-content: space-between;\n      font-size: 40px;\n    }\n  }\n\n  .container__filter {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: end;\n    .chips {\n      @include body1;\n      display: flex;\n      gap: 12px;\n      align-items: center;\n      margin-top: 30px;\n\n      .reset_filter {\n        cursor: pointer;\n        font-size: 14px;\n        color: $c-light-grey;\n        display: flex;\n        gap: 4px;\n        align-items: center;\n      }\n\n      .chips__container {\n        display: flex;\n        gap: 12px;\n      }\n      .chips__container_item {\n        background-color: rgba(220, 220, 220, 0.05);\n        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;\n        border-radius: 100px;\n        padding: 10px 16px;\n        color: #ffffff;\n        cursor: pointer;\n        white-space: nowrap;\n        display: flex;\n        align-items: center;\n        gap: 4px;\n\n        img {\n          display: none;\n        }\n      }\n      .selected_chips__container_item {\n        background: rgba(255, 255, 255, 0.3);\n        color: #fff;\n        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;\n\n        img {\n          display: block;\n        }\n      }\n      .chips__container_divider {\n        color: #fff;\n      }\n    }\n\n    .filter {\n      @include subtitle6m;\n\n      align-items: center;\n      background-color: #3a2159;\n      border-radius: 8px;\n      color: #ae6fff;\n      cursor: pointer;\n      display: flex;\n      gap: 8px;\n      height: 46px;\n      padding: 10px 22px;\n      position: relative;\n      transition: all 0.2s linear;\n\n      .filterWrapper {\n        @include body1;\n\n        background-color: #230432;;\n        border-radius: 8px;\n        color: #e0e0e0;\n        left: 0;\n        padding: 10px 0;\n        position: absolute;\n        top: 100%;\n        max-width: 158px;\n        z-index: 0;\n        white-space: nowrap;\n\n        .filterItem {\n          cursor: pointer;\n          margin-bottom: 9px;\n          padding: 6px 16px;\n          transition: all 0.2s linear;\n          border-radius: 4px;\n\n          &:hover {\n            background-color: rgba(220, 220, 220, 0.1);\n          }\n        }\n\n        .selectedFilter {\n          background-color: rgba(220, 220, 220, 0.1);\n          color: #fff;\n        }\n      }\n\n      &:hover {\n        background-color: #4a2c6f;\n      }\n    }\n\n    .filterModal {\n      display: none;\n    }\n  }\n  .wrapper {\n    align-items: start;\n    display: grid;\n    gap: 24px;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    margin-top: 50px;\n\n    .loaderContainer {\n      @include subtitle1b;\n\n      color: #f9f9f9;\n      display: flex;\n      grid-column: span 4;\n      justify-content: center;\n      margin-top: 50px;\n\n      .loaderWrapper {\n        background-color: $c-white;\n        border-radius: 133px;\n        height: 8px;\n        margin-top: 32px;\n        width: 236px;\n\n        .loader {\n          background-color: #4a2c6f;\n          border-radius: 133px;\n          height: 100%;\n          animation: loader 0.5s ease-in-out forwards;\n          width: 0;\n        }\n      }\n    }\n\n    .empty {\n      @include h3;\n\n      color: $c-white;\n      grid-column: span 4;\n      margin-top: 50px;\n      text-align: center;\n\n      .emptyInfo {\n        @include subtitle5;\n\n        margin-top: 20px;\n\n        .link {\n          color: $c-yellow;\n        }\n      }\n    }\n  }\n\n  .more {\n    display: flex;\n    justify-content: center;\n    margin-top: 40px;\n    position: relative;\n  }\n\n  .up {\n    align-items: center;\n    background-color: #3a2159;\n    border-radius: 8px;\n    cursor: pointer;\n    display: flex;\n    height: 40px;\n    justify-content: center;\n    position: absolute;\n    right: 0;\n    transition: all 0.2s linear;\n    width: 40px;\n\n    &:hover {\n      background-color: #4a2c6f;\n    }\n  }\n  .modalOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1;\n    .modalImage {\n      width: 84px;\n      height: 84px;\n    }\n    .modalContent {\n      background: #2d083e;\n      padding: 20px;\n      border-radius: 8px;\n      max-width: 540px;\n      width: 90%;\n      max-height: 80%;\n      overflow-y: auto;\n      position: relative;\n      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n    }\n    .modalContent_top_button {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      width: 100%;\n      .modalContent_top_button_name {\n        @include subtitle6m;\n        color: #f9f8fa;\n        margin: 0 auto;\n        font-size: 24px;\n      }\n      .modalContent_top_button_x {\n        cursor: pointer;\n      }\n    }\n    .modal_inner {\n      display: flex;\n      flex-direction: column;\n      margin-top: 16px;\n      gap: 16px;\n      .modal_inner_price {\n        border-radius: 100px;\n        width: 120px;\n        height: 28px;\n        \n        .modal_inner_price_p {\n          @include body2;\n          background: rgba(220, 220, 220, 0.1);\n          border-radius: 16px;\n          padding: 6px 8px;\n          width: auto;\n          height: 31px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          font-weight: 400;\n          font-size: 13px;\n          color: #dcdcdc;\n        }\n      }\n      .modal_inner_name {\n        .modal_inner_name_n {\n          @include body2;\n          font-weight: 700;\n          font-size: 20px;\n          color: #ffffff;\n        }\n      }\n      .modal_inner_desc {\n        .modal_inner_desc_d {\n          font-weight: 400;\n          font-size: 14px;\n          color: #e0e0e0;\n          line-height: 1.5em;\n        }\n      }\n    }\n    .modal_inner_buttons {\n      margin-top: 16px;\n      display: flex;\n      flex-direction: row;\n      gap: 16px;\n      justify-content: end;\n      align-items: center;\n\n      .modal_inner_buttons_take {\n        background: #fd4c0a;\n        border-radius: 8px;\n        width: 84px;\n        height: 36px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        .modal_inner_buttons_take_t {\n          font-weight: 500;\n          font-size: 14px;\n          color: #1b1e23;\n          cursor: pointer;\n        }\n      }\n    }\n    .modal_inner_buttons_cancel {\n      display: flex;\n      justify-content: end;\n      .modal_inner_buttons_cancel_c {\n        display: flex;\n        justify-content: end;\n        cursor: pointer;\n      }\n    }\n\n    .closeBtn {\n      position: absolute;\n      top: 10px;\n      right: 10px;\n      background: none;\n      border: none;\n      font-size: 24px;\n      cursor: pointer;\n    }\n  }\n}\n\n@keyframes loader {\n  0% {\n    width: 0;\n  }\n\n  100% {\n    width: 100%;\n  }\n}\n\n@media (max-width: 1200px) {\n  .container {\n    .wrapper {\n      grid-template-columns: 1fr 1fr 1fr;\n    }\n  }\n}\n\n@media (max-width: 1100px) {\n  .container {\n    .container__filter {\n      align-items: flex-start;\n      flex-direction: row;\n      margin-top: 32px;\n      gap: 16px;\n\n      .chips {\n        display: none;\n      }\n\n      .filterModal {\n        background: #fd4c0a;\n        color: #fff;\n        display: flex;\n\n        &:hover {\n          background-color: #fd4c0a;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 920px) {\n  .container__filter {\n    .chips {\n      display: flex;\n      flex-direction: column;\n    }\n    .chips__container_divider {\n      display: none;\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .container {\n    padding-top: 104px;\n    .container__title {\n      .title {\n        display: block;\n        font-size: 36px;\n      }\n    }\n\n    .container__filter {\n      align-items: start;\n      .filter {\n      }\n    }\n\n    .wrapper {\n      grid-template-columns: 1fr;\n      margin-top: 24px;\n\n      .empty {\n        @include subtitle1b;\n\n        .emptyInfo {\n          @include body1;\n\n          margin-top: 20px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .container {\n    .container__line {\n      display: none;\n    }\n    .container__line_mob {\n      margin-top: 20px;\n      display: block;\n      border-radius: 8px;\n      width: 100%;\n      height: 100%;\n      background: rgba(255, 112, 0, 0.25);\n      display: flex;\n      gap: 6px;\n      padding: 10px 10px;\n      align-items: center;\n      .mob_line {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        .title {\n          font-weight: 600;\n          font-size: 18px;\n          line-height: 168%;\n          color: #fff;\n        }\n        .desc {\n          font-family: var(--second-family);\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 173%;\n          color: #ffc785;\n        }\n      }\n    }\n  }\n}\n@media (max-width: 330px) {\n  .container {\n    .container__filter {\n      align-items: flex-start;\n      flex-direction: column-reverse;\n      margin-top: 32px;\n      gap: 16px;\n\n      .chips {\n        display: none;\n      }\n\n      .filterModal {\n        background: #fd4c0a;\n        color: #fff;\n        display: flex;\n\n        &:hover {\n          background-color: #fd4c0a;\n        }\n      }\n    }\n  }\n}\n","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #FD4C0A;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Shop_container__Rufq5`,
	"container__line": `Shop_container__line__TdNwk`,
	"title": `Shop_title__iyk0e`,
	"container__line_mob": `Shop_container__line_mob__SyPyr`,
	"container__title": `Shop_container__title__8fnZF`,
	"container__filter": `Shop_container__filter__FspMS`,
	"chips": `Shop_chips__rCH6K`,
	"reset_filter": `Shop_reset_filter__qOm9O`,
	"chips__container": `Shop_chips__container__Gc8va`,
	"chips__container_item": `Shop_chips__container_item__dZvxn`,
	"selected_chips__container_item": `Shop_selected_chips__container_item__tqYya`,
	"chips__container_divider": `Shop_chips__container_divider__Ud1TA`,
	"filter": `Shop_filter__WLyHN`,
	"filterWrapper": `Shop_filterWrapper__xmtgw`,
	"filterItem": `Shop_filterItem__nc6Uh`,
	"selectedFilter": `Shop_selectedFilter__Xqs1D`,
	"filterModal": `Shop_filterModal__MBXhI`,
	"wrapper": `Shop_wrapper__0a8zU`,
	"loaderContainer": `Shop_loaderContainer__eMAAr`,
	"loaderWrapper": `Shop_loaderWrapper__IRTM8`,
	"loader": `Shop_loader__PVrLC`,
	"empty": `Shop_empty__GgfIa`,
	"emptyInfo": `Shop_emptyInfo__lQmg0`,
	"link": `Shop_link__oVSYa`,
	"more": `Shop_more__FgEWY`,
	"up": `Shop_up__9HpLo`,
	"modalOverlay": `Shop_modalOverlay__mbUG8`,
	"modalImage": `Shop_modalImage__-TgFp`,
	"modalContent": `Shop_modalContent__3ZzSx`,
	"modalContent_top_button": `Shop_modalContent_top_button__uSw-s`,
	"modalContent_top_button_name": `Shop_modalContent_top_button_name__Mz-Xw`,
	"modalContent_top_button_x": `Shop_modalContent_top_button_x__4YHZ7`,
	"modal_inner": `Shop_modal_inner__UlMxW`,
	"modal_inner_price": `Shop_modal_inner_price__Nd91E`,
	"modal_inner_price_p": `Shop_modal_inner_price_p__Vu0-Q`,
	"modal_inner_name": `Shop_modal_inner_name__TeW6E`,
	"modal_inner_name_n": `Shop_modal_inner_name_n__tfh4z`,
	"modal_inner_desc": `Shop_modal_inner_desc__BlsOk`,
	"modal_inner_desc_d": `Shop_modal_inner_desc_d__Wi7w4`,
	"modal_inner_buttons": `Shop_modal_inner_buttons__sbOhH`,
	"modal_inner_buttons_take": `Shop_modal_inner_buttons_take__d4XVI`,
	"modal_inner_buttons_take_t": `Shop_modal_inner_buttons_take_t__kP72n`,
	"modal_inner_buttons_cancel": `Shop_modal_inner_buttons_cancel__U44It`,
	"modal_inner_buttons_cancel_c": `Shop_modal_inner_buttons_cancel_c__evcK+`,
	"closeBtn": `Shop_closeBtn__Bg1v3`,
	"mob_line": `Shop_mob_line__N5FaG`,
	"desc": `Shop_desc__ReiWU`
};
export default ___CSS_LOADER_EXPORT___;
